import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchSetShowPricing, SetCookie } from "@insite/client-framework/Store/Context/Handlers/SetShowPricing"; 

interface Parameter {
    showPricing: boolean;
}

type HandlerType = Handler<Parameter>;

export const SetCookieExtension: HandlerType = props => {};

export const DispatchSetShowPricingExtension: HandlerType = props => {};

replaceInChain(chain, SetCookie, SetCookieExtension);

replaceInChain(chain, DispatchSetShowPricing, DispatchSetShowPricingExtension);